import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=d18ed5ae&scoped=true"
import script from "./PopupLayout.ts?vue&type=script&lang=ts&external"
export * from "./PopupLayout.ts?vue&type=script&lang=ts&external"
import style0 from "./PopupLayout.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PopupLayout.vue?vue&type=style&index=1&id=d18ed5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18ed5ae",
  null
  
)

export default component.exports